import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import PanelLayout from './panel_layout'
import Shortcuts from '../../features/shortcuts'
import capitalize from 'lodash/capitalize'

class ShortcutsPanel extends React.PureComponent {

  render() {
    const { shortcuts, type, noPanel } = this.props

    if (!shortcuts || shortcuts.size < 1) return <div />

    const cleanPre = type === 'list' ? 'Feed' : type === 'trends_rss' ? 'News' : type
    const title = !!type ? capitalize(`${cleanPre} Shortcuts`) : 'Shortcuts'

    return (
      <PanelLayout
        noPadding
        noPanel={noPanel}
        title={title}
        headerButtonTo='/shortcuts'
        headerButtonTitle='Show all'
      >
        <div className={[_s.d, _s.w100PC, _s.boxShadowNone, _s.boxShadowNoneBg].join(' ')}>
          <Shortcuts type={type} size='large' />
        </div>
      </PanelLayout>
    )
  }
}

const mapStateToProps = (state, { type }) => {
  const allShortcuts = state.getIn(['shortcuts', 'items'])
  const shortcuts = !!type ? allShortcuts.filter((s) => s.get('shortcut_type') === type) : allShortcuts
  return {
    shortcuts,
  }
}

ShortcutsPanel.propTypes = {
  type: PropTypes.string,
  noPanel: PropTypes.bool,
}

export default connect(mapStateToProps)(ShortcutsPanel)